



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  SBAR_VERIFY_PLACEHOLDER,
  SBAR_VERIFY_STATEMENT
} from "@/constants/sbar";

@Component
export default class SbarVerifyDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  note = "";
  statement = SBAR_VERIFY_STATEMENT;
  placeholder = SBAR_VERIFY_PLACEHOLDER;

  @Watch("value", { immediate: true })
  onOpenChanged(open: boolean) {
    if (open) {
      this.note = "";
    }
  }
}
